<template>
    <div>
        <div v-if="$permissionHolder.hasPermission('FIRST_ALERT.VIEW_INCIDENTS')">
            <v-dialog :eager="true" v-model="sendMessageDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <SendMessage ref="sendMessageDialog" @close="closeSendMesage" style="height:100%">
                </SendMessage>
            </v-dialog>
            <div v-show="incidents.length > 0">
                <v-data-table :headers="headers"
                              :items="incidents"
                              class="elevation-1"
                              :loading="loading">
                    <template v-slot:item.dateTime="{item}">
                        <date-time-display v-bind:date="item.dateTime"></date-time-display>
                    </template>
                    <template v-slot:item.statusDate="{item}">
                        <date-time-display v-bind:date="item.statusDate"></date-time-display>
                    </template>
                    <template v-slot:item.latitude="{item}">
                        <a :href="'https://maps.google.com/?q='+item.latitude+','+item.longitude" target="_blank">{{item.latitude}} / {{item.longitude}}</a>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-btn icon v-if="$permissionHolder.hasPermission('FIRST_ALERT.COMMUNICATIONS') && item.statusCode != 'CLOSED'" v-on:click="openIncidentCommunications(item.id)">
                            <v-icon dark>mdi-chat</v-icon>
                        </v-btn>
                        <v-btn icon v-if="$permissionHolder.hasPermission('FIRST_ALERT.ANNOUNCE') && item.statusCode != 'CLOSED' " v-on:click="openSendMessage(item.premiseId)">
                            <v-icon dark>mdi-bullhorn</v-icon>
                        </v-btn>
                        <close-incident v-if="item.statusCode != 'CLOSED'" :incident-id="item.id" :is-cad-incident="!item.cadEventType || item.cadEventType == ''" @onClose="afterCloseIncident" icon>
                            <v-icon dark>mdi-close</v-icon>
                        </close-incident>
                    </template>

                </v-data-table>
            </div>
            <div v-show="!incidents || incidents.length == 0" class="ma-5">
                <v-alert type="info" class="mt-1">
                    No Active Incidents To Report
                </v-alert>
            </div>
        </div>
    </div>
</template>

<script>
    import api from "@/api";
    import DateTimeDisplay from "@/components/common/DateTimeDisplay";
    import SendMessage from "@/components/premise/SendMessage";
    import {ORGANIZATION_INCIDENT_CREATED} from '@/events';
    import CloseIncident from "@/components/CloseIncident";
    export default {
        name: "LandingPage",
        components: {SendMessage,DateTimeDisplay,CloseIncident},
        data() {
            return {
                headers: [
                    {text: 'Premise', value: 'premiseName'},
                    {text: 'User', value: 'userName', sortable: false},
                    {text: 'Date / Time', value: 'dateTime'},
                    {text: 'Tracking #', value: 'trackingNumber'},
                    {text: 'Event', value: 'eventText'},
                    {text: 'CAD Event', value: 'cadEventType'},
                    {text: 'Lat / Lng', value: 'latitude'},
                    {text: 'Status', value: 'statusDesc'},
                    {text: 'Status Date', value: 'statusDate'},
                    {text: 'Actions', value: 'actions'}
                ],
                incidents: [],
                loading: false,
                sendMessageDialog:false
            }
        },
        mounted() {
            if (this.$permissionHolder.hasPermission('FIRST_ALERT.VIEW_INCIDENTS')) {
                this.searchIncidents();
            }
        },
        created() {
            // bind listener to when a new incident is created in the admin application
            this.$root.$on(ORGANIZATION_INCIDENT_CREATED,this.searchIncidents);
        },
        beforeDestroy() {
            this.$root.$off(ORGANIZATION_INCIDENT_CREATED,this.searchIncidents);
        },
        methods : {
            afterCloseIncident() {
                this.searchIncidents();
            },
            openSendMessage(premiseId) {
                this.sendMessageDialog = true;
                this.$refs.sendMessageDialog.open(premiseId);
            },
            closeSendMesage() {
                this.sendMessageDialog = false;
            },
            openIncidentCommunications(cadRequestId) {
                this.$router.push({'path': `/incident/${cadRequestId}`});
            },
            searchIncidents : function() {
                this.loading = true;
                api.organization.incidents.getActive(this.$userHolder.getPrimaryOrganizationId()).then((list) => {
                    this.incidents = list;
                    this.loading = false;
                });
            },
        }
    }
</script>

<style scoped>

</style>